import HatcheryAnalysisListStore from './hatchery.list';

export const hatcheryAnalysis = {
    list: HatcheryAnalysisListStore
};
